var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { PeekAddressInput, PeekInput } from "@piiqtechnologies/ui-components";
export const AiDiscoverabilityAddressInput = (_a) => {
    var _b, _c;
    var { mapAPiloaded, field, form } = _a, props = __rest(_a, ["mapAPiloaded", "field", "form"]);
    const normalizedAddressValue = useMemo(() => {
        if (!field.value) {
            return {
                name: "",
                description: "",
                latitude: "",
                longitude: "",
                city: "",
                state: "",
                country: "",
                postalCode: "",
            };
        }
        if (typeof field.value === "string") {
            const value = field.value;
            return {
                name: value,
                description: value,
                latitude: "",
                longitude: "",
                city: "",
                state: "",
                country: "",
                postalCode: "",
            };
        }
        return field.value;
    }, [field.value]);
    if (!mapAPiloaded) {
        const inputValue = typeof field.value === "string" ? field.value : ((_b = field.value) === null || _b === void 0 ? void 0 : _b.description) || ((_c = field.value) === null || _c === void 0 ? void 0 : _c.name) || "";
        return (React.createElement(PeekInput, Object.assign({}, props, { field: Object.assign(Object.assign({}, field), { value: inputValue, onChange: (event) => {
                    field.onChange(event);
                    // @ts-ignore
                    form.setFieldValue(field.name, event.target.value);
                } }), form: form })));
    }
    return React.createElement(PeekAddressInput, Object.assign({}, props, { field: Object.assign(Object.assign({}, field), { value: normalizedAddressValue }), form: form }));
};
export default AiDiscoverabilityAddressInput;
